// import base from "../../../common/base";
export default {
  reactiveVar: (state) => state.reactiveVar,
  minyukinAnkenItems: (state) => state.minyukinAnkenItems,
};
